import {
  authHeader,
  config,
  options,
  handleResponse,
  handleError,
} from "../../common/helpers";
import { Promise } from "es6-promise";

export const assetsHomeServices = {
  getOrgContainers,
  addGroupContainer,
  updateGroupContainer,
  deleteGroupContainer,
  getContainerAssets,
  assetSearchForOrganization,
  containerSearchForOrganization,
  fileUploadToS3,
  postAssetImport,
  getAssetImportStatus,
  getAssetImportStatusOrg,
  addAsset,
  getAssetById,
  updateAsset,
  deleteAsset,
  createAssetSeverity,
  createToolConfig,
  updateToolConfig,
  deleteToolConfig,
  getAddedAlarmsList,
  getAssetsAlarmUnits,
  getAlarmTypes,
  getOrgUsers,
  deleteSelectedAlarm,
  createAlarm,
  updateAlarm,
  getMeasurementGroup,
  updateMeasurementGroup,
  getMoreContainerAssets,
  updateWorkOrder,
  getWorkOrderById,
  validateSerialNumber,
};
function getOrgContainers(organizationId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  const id = organizationId;
  const url = options(
    config.apiUrl + "/organization/" + id + "/container?as_service=true&count=0"
  );
  return fetch(url, requestOptions).then(handleResponse, handleError);
}

function addGroupContainer(groupContainer) {
  let authen = authHeader();
  authen["Content-Type"] = "application/json";
  const requestOptions = {
    method: "PUT",
    headers: authen,
    body: JSON.stringify(groupContainer),
  };
  const url = options(config.apiUrl + "/container");
  return fetch(url, requestOptions).then(handleResponse, handleError);
}

function updateGroupContainer(groupContainer) {
  let authen = authHeader();
  authen["Content-Type"] = "application/json";
  const requestOptions = {
    method: "POST",
    headers: authen,
    body: JSON.stringify(groupContainer),
  };
  const url = options(config.apiUrl + "/container");
  return fetch(url, requestOptions).then(handleResponse, handleError);
}

function deleteGroupContainer(containerId) {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(),
  };
  const url = options(
    config.apiUrl + "/container/" + containerId + "?deepDelete=true"
  );

  return fetch(url, requestOptions).then(handleResponse, handleError);
}

function getContainerAssets(
  organizationId,
  containerId,
  dynamicFilter,
  orderDir,
  orderBy
) {
  let filter = "filter=container.containerId=" + containerId;
  if (dynamicFilter) {
    filter = filter + ":" + dynamicFilter;
  }
  filter = filter + "&count=10&offset=0&";
  if (!orderBy) orderBy = "adminDesc";
  if (!orderDir) orderDir = "asc";
  filter = filter + "orderBy=" + orderBy + "&orderDir=" + orderDir + "&";
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  const url = options(
    config.apiUrl + "/asset?orgId=" + organizationId + "&" + filter
  );
  return fetch(url, requestOptions).then(handleResponse, handleError);
}

function getMoreContainerAssets(
  organizationId,
  containerId,
  dynamicFilter,
  offset,
  orderDir,
  orderBy
) {
  let filter = "filter=container.containerId=" + containerId;
  if (dynamicFilter) {
    filter = filter + ":" + dynamicFilter;
  }
  if (!orderBy) orderBy = "adminDesc";
  if (!orderDir) orderDir = "asc";
  filter = filter + "&orderBy=" + orderBy + "&orderDir=" + orderDir;
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  const url = options(
    config.apiUrl +
      "/asset?orgId=" +
      organizationId +
      "&" +
      filter +
      "&count=10&offset=" +
      offset
  );
  return fetch(url, requestOptions).then(handleResponse, handleError);
}

function assetSearchForOrganization(organizationId, desc, offset, filter) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  const url = options(
    config.apiUrl +
      "/assets/org/" +
      organizationId +
      "?filter=" +
      filter +
      "&offset=" +
      offset +
      "&desc=" +
      desc
  );
  return fetch(url, requestOptions).then(handleResponse, handleError);
}

function containerSearchForOrganization(organizationId, desc, offset) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  const url = options(
    config.apiUrl +
      "/containers/org/" +
      organizationId +
      "?offset=" +
      offset +
      "&desc=" +
      desc
  );
  return fetch(url, requestOptions).then(handleResponse, handleError);
}

function fileUploadToS3(formData, fileKey, isAssetImport) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: formData,
    credentials: "include", // Send cookies with request when cookie-based auth is active
  };
  let requestUrl;
  if (isAssetImport) {
    requestUrl =
      config.s3FileUploadProxy + "?fileKey=" + fileKey + "&isAssetImport=true";
  } else {
    requestUrl = config.s3FileUploadProxy + "?fileKey=" + fileKey;
  }
  return fetch(requestUrl, requestOptions).then(handleResponse, handleError);
}

function postAssetImport(orgId, fileName, parentContainerId) {
  let authen = authHeader();
  let importJson = {
    orgId: orgId,
    parentContainerId: parentContainerId,
    assetImportS3Path: fileName,
  };
  authen["Content-Type"] = "application/json";
  const requestOptions = {
    method: "POST",
    headers: authen,
    body: JSON.stringify(importJson),
  };
  const url = options(config.apiUrl + "/bulkAsset/excel/import");
  return fetch(url, requestOptions).then(handleResponse, handleError);
}

function getAssetImportStatus(importId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  const url = options(config.apiUrl + "/asset/import/" + importId);
  return fetch(url, requestOptions).then(handleResponse, handleError);
}

function getAssetImportStatusOrg(organizationId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  const url = options(
    config.apiUrl + "/asset/importstatus/" + organizationId + "/latest"
  );
  return fetch(url, requestOptions).then(handleResponse, handleError);
}

function addAsset(assetObj) {
  let authen = authHeader();
  authen["Content-Type"] = "application/json";
  const requestOptions = {
    method: "PUT",
    headers: authen,
    body: JSON.stringify(assetObj),
  };
  const url = options(config.apiUrl + "/asset");
  return fetch(url, requestOptions).then(handleResponse, handleError);
}

function getAssetById(assetId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  const url = options(config.apiUrl + "/asset/" + assetId);
  return fetch(url, requestOptions).then(handleResponse, handleError);
}

function updateAsset(assetObj) {
  let authen = authHeader();
  authen["Content-Type"] = "application/json";
  const requestOptions = {
    method: "POST",
    headers: authen,
    body: JSON.stringify(assetObj),
  };
  const url = options(config.apiUrl + "/asset");
  return fetch(url, requestOptions).then(handleResponse, handleError);
}

function deleteAsset(assetId) {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(),
  };
  const url = options(config.apiUrl + "/asset/" + assetId);
  return fetch(url, requestOptions).then(handleResponse, handleError);
}

function createAssetSeverity(assetSeverity) {
  let authen = authHeader();
  authen["Content-Type"] = "application/json";
  const requestOptions = {
    method: "PUT",
    headers: authen,
    body: JSON.stringify(assetSeverity),
  };
  const url = options(config.apiUrl + "/assetseverity");
  return fetch(url, requestOptions).then(handleResponse, handleError);
}

function createToolConfig(toolConfig) {
  let authen = authHeader();
  authen["Content-Type"] = "application/json";
  const requestOptions = {
    method: "PUT",
    headers: authen,
    body: JSON.stringify(toolConfig),
  };
  const url = options(config.apiUrl + "/toolconfig");
  return fetch(url, requestOptions).then(handleResponse, handleError);
}

function updateToolConfig(toolConfig) {
  let authen = authHeader();
  authen["Content-Type"] = "application/json";
  const requestOptions = {
    method: "POST",
    headers: authen,
    body: JSON.stringify(toolConfig),
  };
  const url = options(config.apiUrl + "/toolconfig");
  return fetch(url, requestOptions).then(handleResponse, handleError);
}

function deleteToolConfig(toolConfigId) {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(),
  };
  const url = options(config.apiUrl + "/toolconfig/" + toolConfigId);
  return fetch(url, requestOptions).then(handleResponse, handleError);
}

function getAddedAlarmsList(assetId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  const url = options(config.flukeIotApiUrl + "/asset/" + assetId + "/alarms");
  return fetch(url, requestOptions).then(handleResponse, handleError);
}

function getAssetsAlarmUnits() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  const serviceurl = options(config.flukeIotApiUrl + "/measurementunits");
  const url = serviceurl;
  return fetch(url, requestOptions).then(handleResponse, handleError);
}

function getAlarmTypes(params) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  const serviceurl = options(
    config.flukeIotApiUrl + "/module/" + params + "/alarms"
  );
  const url = serviceurl;
  return fetch(url, requestOptions).then(handleResponse, handleError);
}

function getOrgUsers(params) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  const serviceurl = options(
    config.apiUrl + "/organization/" + params + "/user"
  );
  const url = serviceurl;
  return fetch(url, requestOptions).then(handleResponse, handleError);
}

function deleteSelectedAlarm(alarmId) {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(),
  };
  const url = options(config.flukeIotApiUrl + "/alarm/" + alarmId);
  return fetch(url, requestOptions).then(handleResponse, handleError);
}

function createAlarm(alarmObj) {
  let authen = authHeader();
  authen["Content-Type"] = "application/json";
  const requestOptions = {
    method: "PUT",
    headers: authen,
    body: JSON.stringify(alarmObj),
  };
  const url = options(config.flukeIotApiUrl + "/asset/alarm");
  return fetch(url, requestOptions).then(handleResponse, handleError);
}

function updateAlarm(alarmObj) {
  let authen = authHeader();
  authen["Content-Type"] = "application/json";
  const requestOptions = {
    method: "POST",
    headers: authen,
    body: JSON.stringify(alarmObj),
  };
  const url = options(config.flukeIotApiUrl + "/asset/alarm");
  return fetch(url, requestOptions).then(handleResponse, handleError);
}

function getMeasurementGroup(measGroupid) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };
  const serviceurl = options(
    config.apiMeasUrl + `/measurementgroup/${measGroupid}?details=true`
  );

  return fetch(serviceurl, requestOptions).then(handleResponse, handleError);
}

function updateMeasurementGroup(updatedMeasurementGroup) {
  const serviceurl = options(config.apiMeasUrl + `/measurementgroup/`);
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(updatedMeasurementGroup),
  };
  return fetch(serviceurl, requestOptions).then(handleResponse, handleError);
}

function updateWorkOrder(workOrder) {
  let authen = authHeader();
  authen["Content-Type"] = "application/json";
  const requestOptions = {
    method: "POST",
    headers: authen,
    body: JSON.stringify(workOrder),
  };
  const url = options(config.apiUrl + "/workorder");
  return fetch(url, requestOptions).then(handleResponse, handleError);
}

function getWorkOrderById(workOrderId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  const url = options(config.apiUrl + "/workorder/" + workOrderId);
  return fetch(url, requestOptions).then(handleResponse, handleError);
}

function validateSerialNumber(serialNum) {
  let authen = authHeader();
  authen["Content-Type"] = "application/json";
  const requestOptions = {
    method: "POST",
    headers: authen,
    body: JSON.stringify(serialNum),
  };
  const url = options(config.apiUrl + "/asset/serialnum");
  return fetch(url, requestOptions).then(handleResponse, handleError);
}
